<template>
    <div id="AttenDance">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <img src="./img/icon_img3.png"
                         class="close"
                         @click="close" />
                    <div class="user_info flex jb ac">
                        <div class="name flex ac">
                            <img :src="userInfo.avatarurl?userInfo.avatarurl:'/static/img/default-avatar.png'" class="avatar" />
                            <div class="text">
                                <p class="username">{{userInfo.nickname}}</p>
                                <p class="time flex ac"><span>{{userInfo.vip_name}}</span> | <span>{{userInfo.vip_end_date}}</span></p>
                            </div>
                        </div>
                        <div class="points flex jb ac">
                            <p class="flex ac"><img src="./img/icon_img1.png" />积分：<span>{{userInfo.score_balance}}</span></p>
                          <span class="btn" @click="signClick" v-if="!userInfo.sign_day">领取每日签到积分</span>
                            <span class="btn" v-else>今日已签到，明日再来</span>
                        </div>
                        <img src="./img/icon_img2.png" class="bg" />
                    </div>
                    <!-- <div class="strong_title">
                        <p>积分充值 <span>（充值积分永久有效，全站功能均可使用）</span></p>
                    </div>
                    <div class="points_list">
                        <div class="points_item"
                             @click="choose_price(index)"
                             :class="active_price==index?'active':''"
                             v-for="(item,index) in price_list"
                             :key="index">
                            <p class="name">{{item.name}}</p>
                            <p class="price">￥{{item.price}}</p>
                            <span class="btn">立即购买</span>
                        </div>
                    </div> -->
                    <div class="strong_title">
                        <p>任务列表</p>
                    </div>
                    <div class="task_text flex jb ac">
                        <p class="invite flex ac"><img src="./img/icon_img4.png" /><span>邀请好友注册，得免费积分</span></p>
                        <p class="copy flex ac"><img src="./img/icon_img1.png"
                                 alt=" " /><span>+10/人</span> <span class="btn"  v-clipboard:copy="inviteUrl" v-clipboard:success="copySuccess"
                                                                     v-clipboard:error="copyError">复制链接邀请</span></p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data () {
        return {
            price_list: [
                {
                    id: 1,
                    name: '1100积分包',
                    price: '69',
                },
                {
                    id: 2,
                    name: '1600积分包',
                    price: '99',
                },
                {
                    id: 3,
                    name: '2700积分包',
                    price: '168',
                },
            ],
            active_price: 0,
            todayIsSign:0,
          inviteUrl:"1",
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo;
        },
        isLogin(){
            return this.$store.state.isLogin;
        }
    },
    created () {
        this.todayIsSign = this.getCache("userSign")||0
      this.inviteUrl = MAIN_URLROOT + '/mj/?invite_id='+this.userInfo.uid
    },
    methods: {
        fetchProfile(){
            this.$http.get(`/front/user/profile/`).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                    this.$store.commit('setShowLogin', false)
                    localStorage.setItem("userinfo", JSON.stringify(res.data));
                    localStorage.setItem("invite_code", res.data.invite_code);
                }
            }).finally(() => {

            })
        },
        choose_price (index) {
            this.active_price = index
        },
        close () {
            this.$store.commit('setShowAttenDance', false)
        },
        signClick(){
            if (this.userInfo.is_vip < 1) {
                this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$router.push('/member')
                    this.$store.commit('setisPayPopShow', true)
                    this.$store.commit('setShowAttenDance', false)
                })
                return false
            }
            const today = new Date();
            const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);
            const tomorrowTimestamp = tomorrow.getTime();
            const  now = new Date().getTime()
            const ttl = tomorrowTimestamp - now
            this.$http.post(`/front/aivideo/sign/`).then(res => {
                this.setCache("userSign", 1, ttl)
                this.todayIsSign = 1
              this.$confirm('恭喜您，今日签到成功，成功领取20积分！', '签到', {
                confirmButtonText: '确定',
                type: 'success'
              }).then(() => {
              }).catch(() => {
              });
                this.fetchProfile()
            }).catch(res=>{
                this.$message({
                    message: res.result,
                    type: 'warning',
                })
                this.setCache("userSign", 0, ttl)
                this.todayIsSign = 0
            })
        },
      copySuccess() {
        this.$message.success('复制成功！');
      },
      copyError() {
        this.$message.error('复制失败！');
      },

    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#AttenDance {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        z-index: 88;
        .con {
            position: fixed;
            z-index: 1501;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: transform 0.2s;
            width: 816px;
            background-color: #1e1f22;
            border-radius: 20px;
            padding: 60px 36px;
            .close {
                position: absolute;
                width: 20px;
                height: 20px;
                right: 20px;
                top: 20px;
                z-index: 9;
                cursor: pointer;
                opacity: 0.8;
            }
            .user_info {
                background: #14151a;
                padding: 19px 28px;
                position: relative;
                border-radius: 20px;
                overflow: hidden;
                .bg {
                    position: absolute;
                    top: 10px;
                    right: 20px;
                }
                .name {
                    border-right: 1px solid #353535;
                    padding-right: 100px;

                    .avatar {
                        width: 50px;
                        height: 50px;
                        border-radius: 100%;
                        margin-right: 10px;
                    }
                    .text {
                        .username {
                            font-size: 16px;
                            color: #fff;
                            margin-bottom: 7px;
                        }
                        .time {
                            font-size: 12px;
                            color: #6c6c6c;
                            span {
                                margin: 0 5px;
                            }
                        }
                    }
                }
                .points {
                    flex: 1;
                    padding-left: 50px;
                    position: relative;
                    z-index: 2;
                    p {
                        color: #fff;
                        img {
                            width: 34px;
                            height: 34px;
                            margin-right: 5px;
                        }
                        span {
                            font-size: 16px;
                        }
                    }
                    .btn {
                        background: #38d4ad;
                        line-height: 42px;
                        padding: 0 30px;
                        border-radius: 42px;
                        color: #000;
                        font-weight: bold;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }
            .strong_title {
                margin: 26px 0;
                p {
                    font-size: 16px;
                    color: #fff;
                    font-weight: bold;
                    span {
                        font-size: 14px;
                        color: #a5a5a5;
                        font-weight: normal;
                    }
                }
            }
            .points_list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .points_item {
                    background: #14151a;
                    border-radius: 10px;
                    padding: 20px;
                    border: 2px solid #14151a;
                    color: #fff;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    flex: 0 0 31%;
                    cursor: pointer;
                    .name {
                        font-size: 14px;
                    }
                    .price {
                        font-size: 20px;
                        margin: 9px 15px;
                    }
                    .btn {
                        width: 134px;
                        line-height: 36px;
                        text-align: center;
                        font-size: 12px;
                        border-radius: 6px;
                        border: 1px solid #38d4ad;
                    }
                    &.active {
                        background: #19332e;
                        border-color: #38d4ad;
                        .btn {
                            background: #38d4ad;
                            color: #000;
                        }
                    }
                }
            }
            .task_text {
                background: #14151a;
                padding: 19px 28px;
                border-radius: 10px;
                .invite {
                    font-size: 14px;
                    color: #fff;
                    img {
                        margin-right: 10px;
                    }
                }
                .copy {
                    font-size: 14px;
                    color: #fff;
                    img {
                        width: 22px;
                        height: 22px;
                    }
                    .btn {
                        border: 1px solid #38d4ad;
                        width: 100px;
                        line-height: 30px;
                        text-align: center;
                        color: #38d4ad;
                        margin-left: 30px;
                        border-radius: 6px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>